module.exports = __webpack_public_path__ + "static/media/electronic.63be795b.svg";